module.exports = __webpack_public_path__ + "static/img/section.baf39f9f.png";